// Community Resource Icons - Import directly from SVG files as React components
// Using react-native-svg-transformer for clean, maintainable SVG imports

import AddressBookIcon from './addressBook.svg';
import AidIcon from './aid.svg';
import AlarmIcon from './alarm.svg';
import BackpackIcon from './backpack.svg';
import BedIcon from './bed.svg';
import BicycleIcon from './bicycle.svg';
import BoardIcon from './board.svg';
import BookmarkIcon from './bookmark.svg';
import BookmarkFilledIcon from './bookmark-filled.svg';
import BookOpenIcon from './bookOpen.svg';
import BooksIcon from './books.svg';
import BottleIcon from './bottle.svg';
import BriefcaseIcon from './briefcase.svg';
import BuildingIcon from './building.svg';
import CakeIcon from './cake.svg';
import CalendarIcon from './calendar.svg';
import CarIcon from './car.svg';
import CatIcon from './cat.svg';
import CigaretteIcon from './cigarette.svg';
import ClockIcon from './clock.svg';
import CoffeeIcon from './coffee.svg';
import CubeIcon from './cube.svg';
import DeliveryIcon from './delivery.svg';
import DevicesIcon from './devices.svg';
import DollarIcon from './dollar.svg';
import DoorIcon from './door.svg';
import EntranceIcon from './entrance.svg';
import FileIcon from './file.svg';
import FireIcon from './fire.svg';
import FlagIcon from './flag.svg';
import FolderIcon from './folder.svg';
import GearIcon from './gear.svg';
import GlobeIcon from './globe.svg';
import IdCardIcon from './idCard.svg';
import KeyIcon from './key.svg';
import MaskIcon from './mask.svg';
import MoonIcon from './moon.svg';
import MusicIcon from './music.svg';
import ParkingIcon from './parking.svg';
import PhotoIcon from './photo.svg';
import PrinterIcon from './printer.svg';
import SirenIcon from './siren.svg';
import StackIcon from './stack.svg';
import SwimmingIcon from './swimming.svg';
import TrophyIcon from './trophy.svg';
import WarningIcon from './warning.svg';
import WifiIcon from './wifi.svg';
import WindIcon from './wind.svg';
import WrenchIcon from './wrench.svg';
import SupermarketIcon from './supermarket.svg';

// Community Resource Icons - Direct imports from files as React components
export const COMMUNITY_RESOURCE_ICONS = {
  addressBookIcon: AddressBookIcon,
  aidIcon: AidIcon,
  alarmIcon: AlarmIcon,
  backpackIcon: BackpackIcon,
  bedIcon: BedIcon,
  bicycleIcon: BicycleIcon,
  boardIcon: BoardIcon,
  bookmarkIcon: BookmarkIcon,
  bookmarkFilledIcon: BookmarkFilledIcon,
  bookOpenIcon: BookOpenIcon,
  booksIcon: BooksIcon,
  bottleIcon: BottleIcon,
  briefcaseIcon: BriefcaseIcon,
  buildingIcon: BuildingIcon,
  cakeIcon: CakeIcon,
  calendarIcon: CalendarIcon,
  carIcon: CarIcon,
  catIcon: CatIcon,
  cigaretteIcon: CigaretteIcon,
  clockIcon: ClockIcon,
  coffeeIcon: CoffeeIcon,
  cubeIcon: CubeIcon,
  deliveryIcon: DeliveryIcon,
  devicesIcon: DevicesIcon,
  dollarIcon: DollarIcon,
  doorIcon: DoorIcon,
  entranceIcon: EntranceIcon,
  fileIcon: FileIcon,
  fireIcon: FireIcon,
  flagIcon: FlagIcon,
  folderIcon: FolderIcon,
  gearIcon: GearIcon,
  globeIcon: GlobeIcon,
  idCardIcon: IdCardIcon,
  keyIcon: KeyIcon,
  maskIcon: MaskIcon,
  moonIcon: MoonIcon,
  musicIcon: MusicIcon,
  parkingIcon: ParkingIcon,
  photoIcon: PhotoIcon,
  printerIcon: PrinterIcon,
  sirenIcon: SirenIcon,
  stackIcon: StackIcon,
  swimmingPoolIcon: SwimmingIcon, // Note: mapping swimmingPoolIcon to swimming.svg
  trophyIcon: TrophyIcon,
  warningIcon: WarningIcon,
  wifiBubbleIcon: WifiIcon, // Note: mapping wifiBubbleIcon to wifi.svg
  windIcon: WindIcon,
  wrenchIcon: WrenchIcon,
  supermarketIcon: SupermarketIcon,
} as const;

// Default fallback icon
export const DEFAULT_RESOURCE_ICON = FolderIcon;

// Type definitions for better TypeScript support
export type CommunityResourceIconKey = keyof typeof COMMUNITY_RESOURCE_ICONS;
